<template>
    <div>
        <!-- :maxlength="autogrow ? 70 : -1" -->
        <q-input :label="label" ref="input" :mask="mask" v-model="tel" :model-value="val" :type="type" borderless style="background-color: white; border-radius: 16px; padding: 0 10px 0 10px; border: 2px solid #B2D0EB" input-style="color: black" :debounce="400" :autogrow="autogrow" :loading="loading" :readonly="readOnly">
            <template v-slot:prepend>
                <q-img v-show="svgIcon === 'user'" src="~assets/ui/icons/user.svg" width="26px" height="26px" />
                <q-img v-show="svgIcon === 'book-open'" src="~assets/ui/icons/book-open.svg" width="26px" height="26px" />
                <q-img v-show="svgIcon === 'certificate-icon'" src="~assets/ui/icons/certificate-icon.svg" width="26px" height="26px" />
                <q-img v-show="svgIcon === 'map-pin'" src="~assets/ui/icons/map-pin.svg" width="26px" height="26px" />
                <q-img v-show="svgIcon === 'briefcase'" src="~assets/ui/icons/briefcase.svg" width="26px" height="26px" />
                <q-icon v-show="icon" :name="icon" style="color: #323758" />
            </template>
            <template v-slot:append>
                <div style="color: black" class="text-body2">{{ suffix }}</div>
            </template>
        </q-input>
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'TextInput',
    mixins: [uiControlMixin],
    props: {
        modelValue: {
            type: String,
            default: undefined,
        },
        label: {
            type: String,
            default: undefined,
        },
        type: {
            type: String,
            default: 'text',
        },
        svgIcon: {
            type: String,
            default: undefined,
        },
        mask: {
            type: String,
            default: undefined,
        },
        icon: {
            type: String,
            default: undefined,
        },
        autogrow: {
            type: Boolean,
            default: undefined,
        },
        suffix: {
            type: String,
            default: undefined,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    mounted () {
        this.val = this.modelValue;
    },
    data () {
        return {
            tel: undefined,
            val: undefined,
        };
    },
    watch: {
        modelValue (v) {
            if (v) {
                v = v.replaceAll('.00', ',00');
            }
            this.val = v;
        },
        tel (v) {
            this.val = v;
            this.$emit('update:modelValue', v);
        },
    },
    methods: {
        select () {
            this.$refs.input.select();
        },
    },
};
</script>

<style scoped>

</style>
